import { useState } from "react";

const LazyImage = ({ src, alt, className,style={},banners=false }) => {
  const [isLoading, setIsLoading] = useState(true); // Track loading state

  return (
    <div className="relative h-full w-full">
      {isLoading && (
        <div
          className={`${!banners? className:"h-[450px] sm:h-[800px] md:h-[370px] xl:h-[400px] aspect-square  xl:object-center w-full box-border border-none"} bg-gray-200 animate-pulse`}
          style={{ position: "absolute", top: 0, left: 0 }}
        ></div>
      )}
      <img
        loading="lazy"
        src={src}
        alt={alt}
        style={{...(!banners && {...style})}}
        decoding="async"
            data-nimg="responsive"
        
        className={` ${!banners? className:""} ${isLoading ? "opacity-0" : "opacity-100"} transition-opacity duration-300`}
        onLoad={() => setTimeout(()=>{
            setIsLoading(false)
        },100)} // Hide skeleton when image loads
      />
    </div>
  );
};

export default LazyImage;

// Usage Example
// <LazyImageWithSkeleton
//   src={image?.image_link}
//   alt={`Slide ${index}`}
//   className="h-[25vh] sm:h-[40vh] md:h-[60vh] lg:h-[65vh] xl:h-[80vh] aspect-square xl:object-center w-full box-border border-none"
// />
